define.alias("shared/components/shared/post/profile-selector/available-profile", "calendar/components/shared/post/profile-selector/available-profile/index");